// 应用未加载
export const INITIAL = 'initial';
// 应用加载中
export const LOADING = 'loading';
// 应用已加载但未初始化
export const LOADED = 'loaded';
// 应用初始化中
export const BOOTSTRAPPING = 'bootstrapping';
// 应用已初始化但未挂载
export const BOOTSTRAPPED = 'bootstrapped';
// 应用挂载中
export const MOUNTING = 'mounting';
// 应用已挂载
export const MOUNTED = 'mounted';
// 应用更新数据中
export const UPDATING = 'updating';
// 应用卸载中
export const UNMOUNTING = 'unmounting';
// 应用移除中
export const UNLOADING = 'unloading';
// 应用程序的加载功能返回了被拒绝的承诺
export const LOAD_ERROR = 'load-error';
// 应用程序的初始化功能返回了被拒绝的承诺
export const BOOTSTRAP_ERROR = 'bootstrap-error';
// 应用程序的挂载功能返回了被拒绝的承诺
export const MOUNT_ERROR = 'mount-error';
// 应用程序的更新功能返回了被拒绝的承诺
export const UPDATE_ERROR = 'update-error';
// 应用程序的卸载功能返回了被拒绝的承诺
export const UNMOUNT_ERROR = 'unmount-error';
// 应用程序的移除功能返回了被拒绝的承诺
export const UNLOAD_ERROR = 'unload-error';
